import "./javascript_shared/runtime"
import "./controllers/public_index"

import { startWebVitals } from "./public/web_vitals"
startWebVitals()
